import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { US_MARKET } from '../constants';
import { HANDRAISER_CONFIG_CA, HANDRAISER_CONFIG_US } from '../constants/handraiserConfig';
import { FYMTypes, OffersTypes, SuccessModalTypes } from '../types';
import useDetectDevice from './useDetectDevice';

type PreparedConfig = {
  market: string;
  dealerId: string | null;
  vehicleId: string;
  vehicleType: string;
  modelSalesCode: string | null;
  presetForm: string;
  customForm: string[];
  adobeCloudId: string | null;
  requestType: string | undefined;
  audiCode: string | null;
  carline: string | null;
  ctaInnerText: string | null;
  campaignId: string;
  isOfferPage: boolean;
  offers: OffersTypes | null;
  fym: FYMTypes | null;
  tcpaConsent: string | null | undefined;
  dealerConsent: string | null | undefined;
  dealerConsentFr: string | null | undefined;
  ccpaDisclaimer: string | null | undefined;
  ccpaConsent: string | null | undefined;
  customDepartmentName: string | null;
  customPhoneNumber: string | null;
  successModalConfig: SuccessModalTypes;
  topicOfInterests: string[];
  handraiser: string | null;
};

const useLoadAppConfig = () => {
  const deviceType = useDetectDevice();
  const { i18n } = useTranslation();

  const getAppConfig = useCallback(
    (preparedConfig: PreparedConfig) => {
      const { market, handraiser } = preparedConfig;

      const isUSMarket = market === US_MARKET || market?.toLowerCase().includes('us');

      const selectedConfigOptions = isUSMarket ? HANDRAISER_CONFIG_US : HANDRAISER_CONFIG_CA;

      const handraiserKey = handraiser?.toLowerCase().trim();
      const handraiserConfig =
        handraiserKey && selectedConfigOptions ? selectedConfigOptions[handraiserKey] : null;

      const isFrench = i18n.language?.toLowerCase().startsWith('fr');

      const configPayload = {
        ...preparedConfig,
        device: deviceType,
        ...(handraiserConfig && {
          campaignId: handraiserConfig.campaignId,
          formTitle: isFrench ? handraiserConfig.titleFr : handraiserConfig.title,
          derivativeCode: handraiserConfig.derivativeCode || null,
          successModalConfig: isFrench
            ? handraiserConfig.successModalConfigFr
            : handraiserConfig.successModalConfig || null,

          modelSelect: handraiserConfig.modelSelect || null,
        }),
      };

      return configPayload;
    },
    [deviceType, i18n.language],
  );

  return { getAppConfig };
};

export default useLoadAppConfig;
